module.exports = __webpack_public_path__ + "static/media/kml.4fbb0e88.svg";